document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.tabs__tab');
    const contents = document.querySelectorAll('.tabs__content-wrapper');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const tabId = tab.getAttribute('data-tab-id');

            tabs.forEach(t => t.classList.remove('tabs__tab--active'));
            contents.forEach(c => c.classList.remove('tabs__content-wrapper--active'));

            tab.classList.add('tabs__tab--active');
            document.querySelector(`.tabs__content-wrapper[data-tab-content-id="${tabId}"]`).classList.add('tabs__content-wrapper--active');
        });
    });
});
